import React from "react";

interface MapComponentProps {
  address: string;
  businessName: string;
}

const MapComponent: React.FC<MapComponentProps> = ({
  address,
  businessName,
}) => {
  // Encode the address and business name to ensure they are URL-safe
  const encodedAddress = encodeURIComponent(address);
  const encodedBusinessName = encodeURIComponent(businessName);

  // Construct the src URL dynamically
  const mapSrc = `https://maps.google.com/maps?width=100%25&height=600&hl=en&q=${encodedAddress}+(${encodedBusinessName})&t=&z=14&ie=UTF8&iwloc=B&output=embed`;

  return (
    <div style={{ width: "100%" }}>
      <iframe width="100%" height="400" src={mapSrc} allowFullScreen></iframe>
    </div>
  );
};

export default MapComponent;
